import { Box, Text } from '@chakra-ui/react';
import { SearchFilterInput } from '@texas/components/SearchFilterInput';
import { Icons } from '../Icons';

interface SearchableMenuInputProps {
  autoFocus?: boolean;
  placeholder: string;
  value: string;
  onChange: (value: string) => void;
}

export function SearchableMenuInput({
  autoFocus = false,
  placeholder,
  value,
  onChange,
}: SearchableMenuInputProps) {
  return (
    <Box
      background="entityDirectory.inputBackground"
      position="sticky"
      top={0}
      zIndex={1}
      onClick={(event) => event.stopPropagation()}
      onKeyDown={(event) => event.stopPropagation()}
    >
      <SearchFilterInput
        autoFocus={autoFocus}
        debounceDelay={0}
        height="38px"
        placeholder={placeholder}
        style="entityDirectory"
        value={value}
        onChange={onChange}
      />
    </Box>
  );
}

interface SearchableMenuOptionProps {
  isSelected: boolean;
  label: string;
  showSelectionIndicator?: boolean;
  onClick: () => void;
}

export function SearchableMenuOption({
  isSelected,
  label,
  showSelectionIndicator = false,
  onClick,
}: SearchableMenuOptionProps) {
  return (
    <Box
      as="button"
      alignItems="center"
      color="entityDirectory.text"
      display="flex"
      fontWeight={isSelected ? 'semibold' : 'normal'}
      gap={2}
      px={3}
      py={2}
      role="menuitem"
      textAlign="left"
      type="button"
      w="full"
      _hover={{ background: 'entityDirectory.raisedSurface' }}
      _focusVisible={{
        background: 'entityDirectory.raisedSurface',
        outline: '2px solid',
        outlineColor: 'entityDirectory.primaryBackground',
        outlineOffset: '-2px',
      }}
      onClick={onClick}
    >
      {showSelectionIndicator && (
        <Box flexShrink={0} w={4}>
          {isSelected && <Icons.Checkmark boxSize={4} />}
        </Box>
      )}
      <Text>{label}</Text>
    </Box>
  );
}
